import { Capacitor } from '@capacitor/core'

interface ReviewRecovery {
  ownerId: string
  savedAt: number
  mode: string
  moduleName?: string
  sourceName?: string
  partName?: string
  countLimit?: number
  favoriteOnly?: boolean
  completed?: number
  ids?: string[]
  started?: boolean
  immersive?: { module: string; chapter: string; bookId: string; index: number; started: boolean }
}
const KEY = 'shangan:active-review:v1'
let ownerId = ''
export function setReviewRecoveryOwner(id: string) { ownerId = id }
export function readReviewRecovery(): ReviewRecovery | null {
  if (!ownerId || !Capacitor.isNativePlatform()) return null
  try {
    const data = JSON.parse(localStorage.getItem(KEY) || 'null') as ReviewRecovery | null
    return data && data.ownerId === ownerId && Date.now() - data.savedAt < 12 * 3600000 ? data : null
  } catch { return null }
}
// Only IDs and navigation are persisted. Never serialize card bodies/images here.
export function saveReviewRecovery(patch: Partial<ReviewRecovery>) {
  if (!ownerId || !Capacitor.isNativePlatform()) return
  try { localStorage.setItem(KEY, JSON.stringify({ ...readReviewRecovery(), ...patch, ownerId, savedAt: Date.now() })) } catch { /* IndexedDB remains the answer authority. */ }
}
export function clearReviewRecovery() { try { localStorage.removeItem(KEY) } catch { /* unavailable */ } }
